import { interpret, Machine } from 'xstate';

import { productBuilderMachineConfig } from './config';
import { initialContext } from './initialContext';
import { productBuilderMachineOptions } from './options';

export const productBuilderMachine = interpret(
  Machine(
    productBuilderMachineConfig,
    productBuilderMachineOptions,
  ).withContext(initialContext),
  { devTools: true },
).start();
